import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './KorespondenProfile.scss'
import { ProfileBukopinAPI, BannerProfileAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { Accordion, ThumbnailBig } from '../../../common/components'
import MenuProfile from '../MenuProfile'
import StyledTable from '../../../common/components/StyledTable/StyledTable'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const KorespondenProfileContainer = styled.div`
  background-color: #fff;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
    margin-top: 0;
  }
`

const KorespondenProfile = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [list, setList] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(false)
  const [tabs, setTabs] = useState('list')
  const [search, setSearch] = useState('')
  const [bank, setBank] = useState('')
  const [country, setCountry] = useState('')
  const [city, setCity] = useState('')

  useEffect(async () => {
    setisLoading(true)
    await getDesc()
    loadData()
    loadList()
  }, [])

  const getDesc = async function () {
    const { data } = await BannerProfileAPI({ loc: 'bank_koresponden' })
    setShortDesc(data.data[0])
  }

  const loadData = async function () {
    const { data } = await ProfileBukopinAPI(
      '/bank-koresponden?cat=repository_bank'
    )
    setdata(data.data)
  }

  const loadList = async function () {
    const { data } = await ProfileBukopinAPI('/bank-koresponden?cat=bank')
    setList(data.data)
    setisLoading(false)
  }

  function changeTab(params) {
    setSearch('')
    setBank('')
    setCountry('')
    setCity('')
    setTabs(params)
  }

  let uniqueBank = [...new Set(list.map((x) => x.namaBank))]
  let uniqueNegara = [...new Set(list.map((x) => x.negara))]
  let uniqueKota = [...new Set(list.map((x) => x.kota))]

  let uniqueeBank = [...new Set(data.map((x) => x.namaBank))]
  let uniqueeNegara = [...new Set(data.map((x) => x.negara))]
  let uniqueeKota = [...new Set(data.map((x) => x.kota))]

  return (
    <div>
      <TitleComponent title={shortDesc.title} />
      <Container>
        <ThumbnailBig
          title={isLoading ? '' : shortDesc.title}
          desc={isLoading ? '' : shortDesc.description}
          img={isLoading ? '' : shortDesc.banner}
        />
      </Container>

      <KorespondenProfileContainer>
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12 me-3">
            <div className="mb-5">
              <h2 className="mt-5 mb-4 section-title">
                {t('PilihJenisKoresponden')}
              </h2>
              <div className="row">
                <div className="col-6 pe-0">
                  <div
                    className={
                      tabs == 'list'
                        ? 'tab-active tab text-center'
                        : 'tab text-center'
                    }
                    onClick={() => changeTab('list')}
                  >
                    <p>{t('DaftarBank')}</p>
                    <span></span>
                  </div>
                </div>
                <div className="col-6 ps-0">
                  <div
                    className={
                      tabs == 'repository'
                        ? 'tab-active tab text-center'
                        : 'tab text-center'
                    }
                    onClick={() => changeTab('repository')}
                  >
                    <p>{t('DepositoryBank')}</p>
                    <span></span>
                  </div>
                </div>
              </div>
              {tabs == 'list' ? (
                <div>
                  <div className="row mt-3">
                    <div className="col-12 col-lg-10 pe-lg-0">
                      <div className="search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t('PlaceholderBankKoresponden')}
                          onChange={(event) => {
                            setSearch(event.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-2 ps-lg-0 mt-lg-0 mt-3">
                      <button className="btn btn-primary w-100 h-100">
                        {t('Cari')}
                      </button>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('NamaBank')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setBank(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueBank.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('Negara')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setCountry(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueNegara.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('Kota')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setCity(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueKota.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="row mt-3">
                    <div className="col-12 col-lg-10 pe-lg-0">
                      <div className="search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t('PlaceholderBankKoresponden')}
                          onChange={(event) => {
                            setSearch(event.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-lg-2 ps-lg-0 mt-lg-0 mt-3">
                      <button className="btn btn-primary w-100 h-100">
                        {t('Cari')}
                      </button>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('NamaBank')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setBank(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueeBank.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('Negara')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setCountry(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueeNegara.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                    <div className="col-12 col-lg-4">
                      <label className="mb-1">{t('Kota')}</label>
                      <select
                        className="form-select mb-3"
                        onChange={(event) => {
                          setCity(event.target.value)
                        }}
                      >
                        <option value="" selected>
                          {t('semua')}
                        </option>
                        {uniqueeKota.map((item) => {
                          return <option value={item}>{item}</option>
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mt-3">
                <div className="col-12">
                  {tabs == 'list' ? (
                    <StyledTable>
                      <table>
                        <tr>
                          <td>{t('NamaBank')}</td>
                          <td>{t('Negara')}</td>
                          <td>{t('Kota')}</td>
                          <td>{t('BIC')}</td>
                        </tr>
                        {list
                          .filter((value) => {
                            if (
                              ((value?.namaBank !== null &&
                                value?.namaBank !== undefined &&
                                value?.namaBank
                                  .toString()
                                  .toLowerCase()
                                  .includes(search.toLocaleLowerCase())) ||
                                (value?.negara !== null &&
                                  value?.negara !== undefined &&
                                  value?.negara
                                    .toString()
                                    .toLowerCase()
                                    .includes(search.toLocaleLowerCase())) ||
                                (`${value?.bic}` !== null &&
                                  `${value?.bic}` !== undefined &&
                                  `${value?.bic}`
                                    .toString()
                                    .toLowerCase()
                                    .includes(search.toLocaleLowerCase())) ||
                                (value?.kota !== null &&
                                  value?.kota !== undefined &&
                                  value?.kota
                                    .toString()
                                    .toLowerCase()
                                    .includes(search.toLocaleLowerCase()))) &&
                              value?.namaBank !== null &&
                              value?.negara !== null &&
                              `${value?.bic}` !== null &&
                              value?.kota !== null &&
                              value?.namaBank
                                .toLowerCase()
                                .includes(bank.toLocaleLowerCase()) &&
                              value?.negara
                                .toLowerCase()
                                .includes(country.toLocaleLowerCase()) &&
                              value?.kota
                                .toLowerCase()
                                .includes(city.toLocaleLowerCase())
                            ) {
                              return value
                            }
                          })
                          .map((item) => {
                            return (
                              <tr>
                                <td>{item.namaBank}</td>
                                <td>{item.negara}</td>
                                <td>{item.kota}</td>
                                <td>{item.bic}</td>
                              </tr>
                            )
                          })}
                      </table>
                    </StyledTable>
                  ) : (
                    <StyledTable>
                      <table>
                        <tbody>
                          <tr>
                            <td>{t('NamaBank')}</td>
                            <td>{t('Negara')}</td>
                            <td>{t('Kota')}</td>
                            <td>{t('BIC')}</td>
                          </tr>
                          {data
                            .filter((val) => {
                              if (
                                ((val?.namaBank !== null &&
                                  val?.namaBank !== undefined &&
                                  val?.namaBank
                                    .toString()
                                    .toLowerCase()
                                    .includes(search.toLocaleLowerCase())) ||
                                  (val?.negara !== null &&
                                    val?.negara !== undefined &&
                                    val?.negara
                                      .toString()
                                      .toLowerCase()
                                      .includes(search.toLocaleLowerCase())) ||
                                  (`${val?.bic}` !== null &&
                                    `${val?.bic}` !== undefined &&
                                    `${val?.bic}`
                                      .toString()
                                      .toLowerCase()
                                      .includes(search.toLocaleLowerCase())) ||
                                  (val?.kota !== null &&
                                    val?.kota !== undefined &&
                                    val?.kota
                                      .toString()
                                      .toLowerCase()
                                      .includes(search.toLocaleLowerCase()))) &&
                                val?.namaBank !== null &&
                                val?.negara !== null &&
                                `${val?.bic}` !== null &&
                                val?.kota !== null &&
                                val?.namaBank
                                  .toLowerCase()
                                  .includes(bank.toLocaleLowerCase()) &&
                                val?.negara
                                  .toLowerCase()
                                  .includes(country.toLocaleLowerCase()) &&
                                val?.kota
                                  .toLowerCase()
                                  .includes(city.toLocaleLowerCase())
                              ) {
                                return val
                              }
                            })
                            .map((item) => {
                              return (
                                <tr>
                                  <td>{item.namaBank}</td>
                                  <td>{item.negara}</td>
                                  <td>{item.kota}</td>
                                  <td>{item.bic}</td>
                                </tr>
                              )
                            })}
                        </tbody>
                      </table>
                    </StyledTable>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block col">
            <MenuProfile active={6} />
          </div>
        </div>
      </KorespondenProfileContainer>
      <FooterSection currentPage={t('correspondent_bank')} />
    </div>
  )
}

export default KorespondenProfile
